"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localText = void 0;
exports.localText = {
    exactDate: 'Exact Date',
    selectDate: 'Select Date',
    month: function (month) { return "In ".concat(month, " Months"); },
};
